import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type LogoProps = ComponentPropsWithoutRef<"div"> & {
  /** Primary title; defaults to platform「商家中心」. */
  title?: string;
  /** Subtitle under the title; defaults to「c456」. */
  subtitle?: string;
  /** Replaces the default「C」badge (e.g. BrandIcon in sub-app context). */
  icon?: ReactNode;
};

export function Logo({
  className,
  title = "商家中心",
  subtitle = "c456",
  icon,
  ...props
}: LogoProps) {
  return (
    <div {...props} className={cn("flex items-center gap-2", className)}>
      {icon ?? (
        <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary font-heading text-sm font-bold text-primary-foreground">
          C
        </span>
      )}
      <span className="flex min-w-0 flex-col justify-center gap-0.5 leading-none">
        <span className="truncate font-heading text-base font-semibold tracking-tight">{title}</span>
        <span className="truncate font-heading text-[10px] font-medium tracking-[0.08em] text-muted-foreground">
          {subtitle}
        </span>
      </span>
    </div>
  );
}
